export default __webpack_public_path__ + "fd1bb0c02b79561ff6636249c9b93481.svg";